// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"45b5732b","866":"45b5732b","885":"902f6fad","993":"6cfd4665"}[chunkId] + ".chunk.css";
};